// import data from "./User.json";

export const UserRoleReducer = (state =null, action) => {
  // console.log(state , 'is final user role');
  switch (action.type) {
    case "USERROLE":
      state = action.payload;
      // window.localStorage.setItem("tickets_id",action.payload)
      return state;

    default:
      return state;
  }
};
export const UserAccountLevelReducer = (state =null, action) => {
  // console.log(state , 'is final user role');
  switch (action.type) {
    case "USERACCOUNTLEVEL":
      state = action.payload;
      // window.localStorage.setItem("tickets_id",action.payload)
      return state;

    default:
      return state;
  }
};

// const last_name1 = ( state=data.last_name , action ) => {
//   switch (action.type) {
//     case "LAST_NAME":
//       return state ;
//     default:
//       return state;
//   }
// };
// const email1 = (state =data.email  , action) => {
//   switch (action.type) {
//     case "EMAIL":
//       return state;
//     default:
//       return state;
//   }
// };
// const name1 = (state = data.name , action) => {
//   switch (action.type) {
//     case "NAME":
//       return state;
//     default:
//       return state;
//   }
// };
// const coName1 = (state = data.coName , action) => {
//   switch (action.type) {
//     case "CONAME":
//       return state;
//     default:
//       return state;
//   }
// };
// const phone1 = (state = data.phone , action) => {
//   switch (action.type) {
//     case "PHONE":
//       return state;
//     default:
//       return state;
//   }
// };
// const website1 = (state = data.website , action) => {
//   switch (action.type) {
//     case "WEBSITE":
//       return state;
//     default:
//       return state;
//   }
// };
// const country1 = (state = data.country , action) => {
//   switch (action.type) {
//     case "COUNTRY":
//       return state;
//     default:
//       return state;
//   }
// };
// const city1 = (state = data.city , action) => {
//   switch (action.type) {
//     case "CITY":
//       return state;
//     default:
//       return state;
//   }
// };
// const code_p1 = (state = data.code_p , action) => {
//   switch (action.type) {
//     case "CODE_P":
//       return state;
//     default:
//       return state;
//   }
// };
// const addres1 = (state = data.addres , action) => {
//   switch (action.type) {
//     case "ADDRES":
//       return state;
//     default:
//       return state;
//   }
// };
// const code_m1 = (state = data.code_m , action) => {
//   switch (action.type) {
//     case "CODE_M":
//       return state;
//     default:
//       return state;
//   }
// };

// export  {
//   last_name1,
//   email1,
//   name1,
//   code_m1,
//   addres1,
//   code_p1,
//   website1,
//   country1,
//   city1,
//   phone1,
//   coName1,
// };
